import React from 'react';

class ShoppingCart {
    render() {
        return null;
    }
}
export default ShoppingCart;
